/**
 * `@workspace/strings/common` — the minimal shared surface.
 *
 * For framework-agnostic, non-React consumers that only need the truly-shared
 * atoms: the pure-logic player lib (`@workspace/player-core`) and any generic
 * Node/TS caller. Keep this catalog tiny.
 */
import { createT, getLocale, setLocale } from "../core.ts";
import { common } from "../en/common.ts";
import { player } from "../en/player.ts";

const en = { common, player } as const;
const catalogs = { en } as const;

export const t = createT<typeof en>(
  () => catalogs[getLocale() as keyof typeof catalogs] ?? en,
);

export { setLocale, getLocale };
export const strings = en;
export type CommonStrings = typeof en;
